module.exports = __webpack_public_path__ + "static/media/akiresuken.680c093c.png";